export default "__VITE_ASSET__ce234b41__"